/**
 * Red "Didn't arrive" mark for an invoice whose last email bounced
 * (lifecycle audit, 10/29). The server sends `bounce` only while no later
 * email of the invoice has reached the customer (invoiceBounceSql), so the
 * mark goes away by itself after a good "Send it again".
 */
export interface InvoiceBounce {
    at: string;
    to: string;
    reason: string | null;
    status?: string;
}

/** Plain words for the hover: who, when, why, and what to do. */
export function invoiceBounceTitle(b: InvoiceBounce): string {
    const when = new Date(b.at).toLocaleDateString("en-US", { month: "short", day: "numeric" });
    const why = b.reason?.trim() ? ` ${b.reason.trim()}` : "";
    return `The invoice email to ${b.to} didn't arrive (${when}).${why} Fix the address on the customer's Contacts tab, then press Send it again.`;
}

export function InvoiceBounceMark({ bounce }: { bounce: InvoiceBounce | null | undefined }) {
    if (!bounce) return null;
    return (
        <span
            className="inline-flex shrink-0 items-center rounded border border-destructive/40 bg-destructive/10 px-1.5 py-0.5 text-[10px] font-semibold text-destructive"
            title={invoiceBounceTitle(bounce)}
            data-testid="invoice-bounce-mark"
        >
            Didn&apos;t arrive
        </span>
    );
}
